import { useAppDispatch } from 'store/hooks';
import { closeModal } from 'features/modal/modalSlice';
import { useTranslation } from 'react-i18next';
import ConfirmationDialog from 'components/ConfirmationDialog';

const RecordingFailureRuntimeModal = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation('modals');

  const handleClose = () => dispatch(closeModal('recordingFailureRuntime'));

  return (
    <ConfirmationDialog
      open
      title={t('recording_failure_runtime.title')}
      description={t('recording_failure_runtime.description')}
      okText={t('recording_failure_runtime.btn_ok_label')}
      onOk={handleClose}
      onCancel={handleClose}
    />
  );
};

export default RecordingFailureRuntimeModal;
